'use client';

import { createContext, useContext } from 'react';

export type SectionStatus = 'configured' | 'needs-setup' | 'optional';

export interface SectionMeta {
    id: string;
    title: string;
    description?: string;
    status?: SectionStatus;
    keywords?: string;
}

export interface SettingsPanelContextValue {
    activeId: string | null;
    searchQuery: string;
    baseUrl: string | null;
    activate: (id: string) => void;
    register: (meta: SectionMeta) => void;
    unregister: (id: string) => void;
}

export const SettingsPanelContext = createContext<SettingsPanelContextValue | null>(null);

export function useSettingsPanel() {
    const ctx = useContext(SettingsPanelContext);
    if (!ctx) throw new Error('useSettingsPanel must be used inside SettingsPanelLayout');
    return ctx;
}
